<template>
  <div v-if="showModal" class="modal-overlay">
    <div class="modal-content"><!---->
      <div class="banner">
        <img :src="config.HOST+ currentImage"/>
        <button class="close-btn" @click="showModal = false">
<!--          ✕-->
<!--          <i class="isax isax-close-circle"></i>-->
          <i class="uil uil-times"></i>
        </button>
        <div class="buttons" v-if="bannerData.link">
          <a :href="bannerData.link" target="_blank">Дэлгэрэнгүй</a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import api from "@store/_boot/baseApi";
import config from "@store/_boot/config";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,

    }
  },

  data() {
    return {
      showModal: this.visible,
      bannerData: "",
      loadingBanner: false,
      config: config,
      windowWidth: window.innerWidth
    };
  },
  computed: {

    currentImage() {
      console.log('this.windowWidth', this.windowWidth);
      return this.windowWidth < 768
          ? this.bannerData.mobile_image
          : this.bannerData.image
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },
  created() {
    this.getBanner();
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    getBanner() {
      this.loadingBanner = true;
      api.get('api/banner/web-banner')
          .then((res) => {
            this.bannerData = res.data.data;
            this.loadingBanner = false;

            const today = new Date().toISOString().slice(0, 10);
            const shownDate = sessionStorage.getItem('bannerShownDate');

            if (this.bannerData.view_type === 1) {
              // Хуудас ачааллах бүрт харуулах
              this.showModal = true;
            } else if (this.bannerData.view_type === 0) {
              console.log("today", today)
              console.log("shownDate", shownDate)
              if (shownDate !== today) {
                console.log("iishee-----")
                this.showModal = true;
                sessionStorage.setItem('bannerShownDate', today);
              } else {
                this.showModal = false;
                console.log("showModal", this.showModal);
              }
            }
          })
          .catch((err) => {
            console.error("Banner fetch error", err);
            this.loadingBanner = false;
          });
    }

  }
};
</script>


